import React, {Children, useEffect, useState} from 'react';
import {Grid, Row, Col} from 'react-styled-flexboxgrid';
import Alert from 'reusecore/src/elements/Alert';
import Box from 'reusecore/src/elements/Box';
import {Counter} from '../../helpers/Counter';
import {db} from '../../helpers/firebaseHelper';
import getPhotos, {LARGE, MEDIUM} from '../../helpers/getPhotos';
import useMediaQuery from '../../helpers/mediaQuery';
import Description from './Description';
import RelatedPost from './RelatedPost';
import Lightbox from 'react-image-lightbox';
import Heading from 'reusecore/src/elements/Heading';
import Contact from './Contact';
import {
  SinglePageDescriptionLoader,
  SliderLoader,
} from '../../components/Loader';
import {Carousel, SectionWrapper} from './singlePost.style';
import Breadcrumb from '../../components/Breadcrumb';
import {useTranslation} from 'next-i18next';
import Credical from "../../components/CreditSimulator/credical";

const SinglePost = props => {
  const {data, loading, error, QUERY_VARIABLES} = props;

  const {t} = useTranslation();
  const [currImg, setCurrImg] = useState(0);
  const [viewIsOpen, setViewIsOpen] = useState(false);

  const isMobile = useMediaQuery('(max-width: 1023px)');

  const {post = {}} = data || {};

  const {
    category = '',
    id,
    media = [],
    photos = [],
    related = [],
    title = '',
    town,
  } = post;

  const postGallery = getPhotos(media, photos, MEDIUM);
  let postGalleryLarge = getPhotos(media, photos, LARGE);

  postGalleryLarge = postGalleryLarge.map(photo => {
    const {thumbnail: {contentUrl} = {}} = photo;
    if (contentUrl) {
      photo.contentUrl = contentUrl;
    }

    return photo;
  });

  const Loader = () => (
    <Row>
      <Col sm={8}>
        <SliderLoader/>
      </Col>
      <Col sm={4}>
        <SinglePageDescriptionLoader/>
      </Col>
    </Row>
  );

  const gotoNext = () => {
    setCurrImg((currImg + 1) % postGalleryLarge.length);
  };
  const gotoPrevious = () => {
    setCurrImg(
      (currImg + postGalleryLarge.length - 1) % postGalleryLarge.length
    );
  };
  const closeImgsViewer = () => {
    setViewIsOpen(false);
  };
  const getZoom = () => {
    setViewIsOpen(true);
  };

  useEffect(() => {
    if (id) {
      // Initialize the sharded counter.
      const visits = new Counter(db.collection('ads').doc(id), 'stats.visits');

      // Increment the field "visits" of the document
      visits.incrementBy(1);
    }
  }, [id]);

  if (error) return <Alert>{`Error! ${error.message}`}</Alert>;

  return (
    <SectionWrapper>
      <Grid>
        <Breadcrumb category={category} town={town} title={title}/>
        {loading ? (
          <Loader/>
        ) : (
          <Row>
            <Col
              sm={7}
              md={8}
              xs={12}
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                marginBottom: 30,
              }}
            >
              {postGallery && postGallery.length > 0 && (
                <div style={{position: 'relative'}}>
                  <Carousel
                    showThumbs={!isMobile && postGallery.length > 1}
                    showIndicators={false}
                    showStatus={false}
                    onClickItem={getZoom}
                    selectedItem={currImg}
                    onChange={index => setCurrImg(index)}
                    style={{maxHeight: '55vh'}}
                    renderThumbs={function (children) {
                      // override renderThumbs to allow picture
                      const images = Children.map(children, item => {
                        let img = item;
                        // if the item is not an image, try to find the first image in the item's children.
                        if (item.type !== 'img' && item.type !== 'picture') {
                          img = Children.toArray(item.props.children).find(
                            children => {
                              return (
                                children.type === 'img' ||
                                children.type === 'picture'
                              );
                            }
                          );
                        }
                        if (!img) {
                          return undefined;
                        }
                        return img;
                      });
                      if (
                        images.filter(function (image) {
                          return image;
                        }).length === 0
                      ) {
                        console.warn(
                          "No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md"
                        );
                        return [];
                      }
                      return images;
                    }}
                  >
                    {postGallery.map((image, index) => {
                      const {
                        contentUrl,
                        height = null,
                        source = null,
                        thumbnail,
                        width = null,
                      } = image;
                      const {
                        contentUrl: thumbnailContentUrl,
                        height: thumbnailHeight = null,
                        source: thumbnailSource = null,
                        width: thumbnailWidth = null,
                      } = thumbnail || {};

                      const imgSrc = thumbnail
                        ? thumbnailContentUrl
                        : contentUrl;
                      const imgHeight = thumbnail ? thumbnailHeight : height;
                      const imgSource = thumbnail ? thumbnailSource : source;
                      const imgWidth = thumbnail ? thumbnailWidth : width;

                      return (
                        <div key={index} style={{height: '100%'}}>
                          <picture>
                            {imgSource}
                            <img
                              alt=""
                              src={imgSrc}
                              height={imgHeight}
                              width={imgWidth}
                              style={{
                                maxWidth: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                maxHeight: '55vh',
                                cursor: 'pointer',
                              }}
                            />
                          </picture>
                        </div>
                      );
                    })}
                  </Carousel>
                  {viewIsOpen && (
                    <Lightbox
                      mainSrc={postGalleryLarge[currImg].contentUrl}
                      nextSrc={
                        postGalleryLarge.length > 1
                          ? postGalleryLarge[
                          (currImg + 1) % postGalleryLarge.length
                            ].contentUrl
                          : ''
                      }
                      prevSrc={
                        postGalleryLarge.length > 1
                          ? postGalleryLarge[
                          (currImg + postGalleryLarge.length - 1) %
                          postGalleryLarge.length
                            ].contentUrl
                          : ''
                      }
                      onCloseRequest={closeImgsViewer}
                      onMovePrevRequest={gotoPrevious}
                      onMoveNextRequest={gotoNext}
                    />
                  )}
                </div>
              )}

              <Description loading={loading} postData={post}/>
            </Col>
            <Col
              sm={5}
              md={4}
              xs={12}
              style={{
                paddingLeft: 15,
                paddingRight: 15,
              }}
            >
              <Contact loading={loading} postData={post}/>
            </Col>
            {
              (post.category === 'Voitures' && process.env.SKAZY_AD_CREDICAL == 1) && (
                <Credical origPrice={post.price}/>
              )
            }
          </Row>
        )}

        <Row style={{margin: 0}}>
          <Box
            mt={50}
            flexBox={true}
            justifyContent="space-between"
            style={{width: '100%'}}
          >
            {related && related.length ? (
              <Heading
                content={t('adsView.related')}
                as="h2"
                fontSize={18}
                fontWeight={600}
                color="#002F3F"
                fontFamily="'Lato',sans-serif"
                style={{margin: 0, marginBottom: 20}}
              />
            ) : (
              <div/>
            )}
          </Box>
          <RelatedPost
            related={related}
            id={id}
            loading={loading}
            limit={QUERY_VARIABLES.LIMIT}
          />
        </Row>
      </Grid>
    </SectionWrapper>
  );
};

export default SinglePost;
